import { render, staticRenderFns } from "./WhatsappBusinessMessage.vue?vue&type=template&id=d65a2fe4"
import script from "./WhatsappBusinessMessage.vue?vue&type=script&lang=js"
export * from "./WhatsappBusinessMessage.vue?vue&type=script&lang=js"
import style0 from "./WhatsappBusinessMessage.vue?vue&type=style&index=0&id=d65a2fe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports